<template>
  <base-dialog
  ref="base"
  v-model="model"
  width="700"
  title="dialogs.titles.addRepairPart"
  header-bg="blue">
    <attachment-dialog
    v-if="attachmentDialog.model"
    v-model="attachmentDialog.model"
    :attachments.sync="attachmentDialog.attachments"/>
    <v-form
    ref="form"
    class="px-5 py-3"
    v-model="form">
      <v-row
      dense>
        <v-col cols="6">
          <part-category-autocomplete
          v-model="category"
          outlined
          :label="$t('textFields.category')"
          @selected="clearPartIfCategoryIsEmpty"
          class="mr-2"/>
        </v-col>
        <v-col cols="6">
          <text-field-parts
          :label="$t('textFields.part')"
          v-model="part"
          :category="category"
          :disabled="!category"
          service-category="REPAIR"
          normal
          outlined
          required
          class="ml-2"/>
        </v-col>
      </v-row>
      <v-row
      dense>
        <v-col cols="6">
          <text-field-value-with-label
          v-model="serialNumber"
          required
          outlined
          :label="$t('textFields.serialNumber')"
          class="mr-2"/>
        </v-col>
        <v-col cols="6">
          <text-field-value-with-label
          v-model="serviceTag"
          outlined
          :label="$t('textFields.serviceTag')"
          class="ml-2"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <text-area-with-label
          v-model="problemDescription"
          outlined
          :label="$t('textFields.problemDescription')"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <attachments-dialog-trigger
          @click="openAttachmentsDialog"
          :attachments="attachments"
          editable/>
        </v-col>
      </v-row>
      <v-row class="mt-10">
        <v-col class="d-flex justify-center align-center">
          <primary-btn
          :disabled="!form"
          :label="$t(`btns.add`)"
          color="#4285f4"
          @click="tryToAdd"
          :loading="loading"
          :width="120"
          :height="40"/>
        </v-col>
      </v-row>
    </v-form>
  </base-dialog>
</template>
<script>
import BaseDialog from '@/components/dialogs/BaseDialog'
import PartCategoryAutocomplete from '@/components/text-fields/PartCategoryAutocomplete'
import TextFieldParts from '@/components/text-fields/TextFieldParts'
import TextFieldValueWithLabel from '@/components/text-fields/TextFieldValueWithLabel'
import TextAreaWithLabel from '@/components/text-fields/TextAreaWithLabel'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import AttachmentDialog from '@/components/dialogs/AttachmentDialog'
import AttachmentsDialogTrigger from '@/components/common/triggers/AttachmentsDialogTrigger'

import { addRepairPart } from "@/repositories/repairRepo"
import { execHttpRequestThrowable } from "@/services/http"
export default {
  components: {
    BaseDialog,
    PartCategoryAutocomplete,
    TextFieldParts,
    TextFieldValueWithLabel,
    TextAreaWithLabel,
    PrimaryBtn,
    AttachmentsDialogTrigger,
    AttachmentDialog
  },
  props: {
    value: Boolean,
    repairId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: false,
      category: null,
      part: null,
      serialNumber: null,
      serviceTag: null,
      problemDescription: null,
      attachments: [],

      attachmentDialog: {
        model: false
      },

      loading: false
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    }
  },
  methods: {
    clearPartIfCategoryIsEmpty() {
      if (this.category === null) {
        this.part = null
        this.quantity = null

        this.$refs.form.resetValidation()
      }
    },
    async tryToAdd() {
      try {
        this.loading = true
        const DATA = {
          serialNumber: this.serialNumber,
          serviceTag: this.serviceTag,
          problemDescription: this.problemDescription,
          partId: this.part.id,
          attachments: this.attachments
        }
        // console.log(DATA, this.repairId)

        const r = await execHttpRequestThrowable(async () => addRepairPart(this.repairId, DATA))
        this.$emit("add", r.response.data)
        this.$refs.base.closeDialog()
      }
      finally {
        this.loading = false
      }
    },
    openAttachmentsDialog() {
      this.attachmentDialog = {
        model: true,
        attachments: this.attachments
      }
    },
  }
}
</script>
<style>
</style>